import script from "./RelapsePreventionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./RelapsePreventionPlans.vue?vue&type=script&setup=true&lang=js"

import "./RelapsePreventionPlans.vue?vue&type=style&index=0&id=6d8139b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8139b0"]])

export default __exports__